import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-player-game-log',
  templateUrl: './player-game-log.component.html',
  styleUrls: ['./player-game-log.component.scss']
})
export class PlayerGameLogComponent {

  public data: any = { match: 'exact' };
  public load = false;
  public items: any = [];
  public games: any = [];
  public statistic: any = {};
  public page_nat: any = { page_nat: [] };

  // Per-row expand state for the sportsbook match-detail drawer (keyed by bet id).
  public expanded: any = {};

  @Output() closeEvent = new EventEmitter();

  @Input() set setPlayer(player: any) {
    if (!player) return;
    this.data.code = player.code;
    const date = new Date();
    this.data.date_from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + 'T00:00';
    this.data.date_to   = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + 'T23:59';
    this.filter();
  }

  constructor(private http: HttpService) {
    this.http.post('/admin/integrated-game/get-games').then((y: any) => {
      this.games = y.games;
    });
  }

  async filter(page_no = 1) {
    this.load = true;
    this.data.page_no = page_no;
    const y: any = await this.http.post('/admin/integrated-game/game-log', this.data);
    if (y.status && y.items) {
      this.items = y.items;
      this.statistic = y.total_summary;
      this.page_nat = y.page_nat;
    } else {
      this.items = [];
      this.statistic = { total_bet: 0, total_winloss: 0, total_bonus: 0 };
      this.page_nat = { current_page: 1, page_limit: 200 };
    }
    this.load = false;
  }

  statusUpdate(status) {
    switch (status) {
      case 1: return 'Completed';
      case 2: return 'Pending';
      case 9: return 'Canceled';
    }
  }

  sum(key: string) {
    return this.items.reduce((acc: any, item: any) => acc + parseFloat(item[key] ?? 0), 0);
  }

  // ---- Sportsbook match detail (bet.game_detail = AWC gameInfo.legs[]) ----

  // True when the row carries captured match detail (PINNACLE / sportsbook events).
  hasDetail(item: any): boolean {
    const gd = item && item.game_detail;
    return !!(gd && Array.isArray(gd.legs) && gd.legs.length > 0);
  }

  // One-line summary shown in the Match column: the first event + a leg count for parlays.
  matchSummary(item: any): string {
    if (!this.hasDetail(item)) return '';
    const legs = item.game_detail.legs;
    const first = legs[0] || {};
    const event = first.eventName || ((first.homeTeam && first.awayTeam) ? (first.homeTeam + ' vs ' + first.awayTeam) : '');
    const head = (first.sportName || item.game_detail.sportName || 'Match');
    let label = event ? (head + ': ' + event) : head;
    if (legs.length > 1) label += ' (+' + (legs.length - 1) + ' more)';
    return label;
  }

  toggleExpand(item: any) {
    if (!this.hasDetail(item)) return;
    const k = '' + (item.id ?? item.transaction_id);
    this.expanded[k] = !this.expanded[k];
  }

  isExpanded(item: any): boolean {
    return !!this.expanded['' + (item.id ?? item.transaction_id)];
  }

  // Readable selection line for one leg, e.g. "Match Handicap -> Over +4.75  @ 2.11".
  legSelection(leg: any): string {
    const parts: string[] = [];
    if (leg.marketName || leg.betType) parts.push(leg.marketName || leg.betType);
    let sel = leg.selection || '';
    if (leg.handicap !== null && leg.handicap !== undefined && leg.handicap !== '') {
      const h = parseFloat(leg.handicap);
      sel += (Number.isFinite(h) ? (' ' + (h > 0 ? '+' : '') + h) : (' ' + leg.handicap));
    }
    if (sel) parts.push(sel.trim());
    let line = parts.join(' → ');
    if (leg.odds !== null && leg.odds !== undefined) line += '  @ ' + leg.odds;
    return line.trim();
  }

  legResultClass(leg: any): string {
    const s = ('' + (leg.legStatus || '')).toUpperCase();
    if (s.indexOf('WON') !== -1 || s === 'WIN') return 'text-success';
    if (s.indexOf('LOST') !== -1 || s.indexOf('LOSE') !== -1) return 'text-danger';
    if (s.indexOf('VOID') !== -1 || s.indexOf('CANCEL') !== -1 || s.indexOf('REFUND') !== -1) return 'text-muted';
    return '';
  }

  close() {
    this.closeEvent.emit();
  }
}
